export function firePlausibleGoal(goalName: string, props = {}) {
  const plausible = (window as any).plausible
  if (plausible) {
    // If you add a new property, consider if it should be added to plausible.slim as well
    plausible(goalName, { props: { logged_in: 'true', site: 'application', ...props } })
  }
}
